import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { LoadingState } from '../../../components/loading/loading.component';
import { FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms';
import { projectSiteServices } from '../../../services/project-sites.service';
import { reportingService } from '../../../services/reporting.service';
import { SettingService } from '../../../services/setting.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-daily-progess',
  templateUrl: './daily-progess.component.html',
  styleUrls: ['./daily-progess.component.scss']
})
export class DailyProgessComponent implements OnInit {

  loading: LoadingState = LoadingState.NotReady;
  form: FormGroup;
  boqDescription = null;
  @Input() sitearr: any = [];
  @Input() machinearr: any = [];
  @Input() unitarr: any = [];
  @Input() employeeList: any = [];
  @Input() progressDetailsData: any;
  @Input() contractorList: any = [];
  @Input() projectList: any = [];
  @Input() boqList: any = [];
  @Input() reasonForWeeklyShortageStatus: boolean;
  @Input() activityList: any = [];
  @Output() setDetailsData = new EventEmitter<any>();
  @Output() setSiteData = new EventEmitter<any>();
  @Output() setBoqData = new EventEmitter<any>();

  constructor(private formBuilder: FormBuilder,
    public sitesService: projectSiteServices,
    public reportService: reportingService,
    public settingService: SettingService,
    private toastr: ToastrService,
  ) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      type_of_report: 1,
      project_id: [null, Validators.required],
      site_location: [null, Validators.required],
      date_entry: [null, Validators.required],
      weather: ['', Validators.required],
      date_of_completion: [null, Validators.required],
      milestone_to_be_completed: ['', Validators.required],
      boq: ['', Validators.required],
      rainfall_from: [null],
      rainfall_to: [null],
      temperature_in_cel: ['', Validators.required],
      ir_problem: null,
      local_issue: null,
      client_visit: null,
      administrative_issue: null,
      document_ir: [null],
      document_li: [null],
      document_cv: [null],
      document_ai: [null],
      reason_for_weekly_shortage: null,
      reason_for_cumulative_shortage: null,
      mitigation_plan_weekly_shortage: null,
      mitigation_plan_cumulative_shortage: null,
      progress_data: this.formBuilder.array([this.addProgressDataFormGroup()])
    });
    
    if (this.progressDetailsData == undefined) {
      this.progressDetailsData = {
        project_id: null,
        site_location: null,
        date_entry: null,
        date_of_completion: null,
        weather: '',
        milestone_to_be_completed: '',
        boq: '',
        temperature_in_cel: '',
        rainfall_from: null,
        rainfall_to: null,
        ir_problem: null,
        local_issue: null,
        client_visit: null,
        administrative_issue: null,
        reason_for_weekly_shortage: '',
        reason_for_cumulative_shortage: '',
        mitigation_plan_weekly_shortage: '',
        mitigation_plan_cumulative_shortage: '',
      }
    } else {
      if(this.progressDetailsData.date_entry != null) {
        this.onProgressDateSelected();
      }
    }
    this.loading = LoadingState.Ready;
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.reasonForWeeklyShortageStatus) {
      this.reasonForWeeklyShortageStatus = changes.reasonForWeeklyShortageStatus.currentValue;
    }
  }

  /* FormGroup custom validators with range value
    Author - Biswajit Manna */
  addProgressDataFormGroup(): FormGroup {
    return this.formBuilder.group({
      activity_id: [null, Validators.required],
      description: ['', Validators.required],
      uom_id: [null, Validators.required],
      planned_start_time: [null, Validators.required],
      planned_end_time: [null, Validators.required],
      actual_start_time: [null, Validators.required],
      actual_end_time: [null, Validators.required],
      archieved_quantity: ['', Validators.required],
      assigned_to_id: [null, Validators.required],
      contractors_name_id: [null, Validators.required],
      remarks: [''],
      major_achivements: [''],
      date_entry: [null],
      date_of_completion: [null]
    }, { validators: [this.check_planned_end_time, this.check_actual_end_time] });
  }
  /* FormGroup custom validators with range value
    Author - Biswajit Manna */
  check_planned_end_time(group: FormGroup) {
    if (group.controls.planned_start_time.value != null && group.controls.planned_end_time.value != null) {
      let planned_start_time = group.controls.planned_start_time.value['hour'] + ':' + group.controls.planned_start_time.value['minute'] + ':' + group.controls.planned_start_time.value['second'];
      let planned_end_time = group.controls.planned_end_time.value['hour'] + ':' + group.controls.planned_end_time.value['minute'] + ':' + group.controls.planned_end_time.value['second'];
      var date_entry = group.controls.date_entry.value;
      var date_of_completion = group.controls.date_of_completion.value;
      if (date_entry != null && date_of_completion != null) {
        date_entry = group.controls.date_entry.value;
        date_of_completion = group.controls.date_of_completion.value;
        date_entry = date_entry.month + '/' + date_entry.day + '/' + date_entry.year;
        date_of_completion = date_of_completion.month + '/' + date_of_completion.day + '/' + date_of_completion.year;
        return Date.parse(date_of_completion + ' ' + planned_end_time) > Date.parse(date_entry + ' ' + planned_start_time) ? null : { notGreater: true }
      }
      else {
        return Date.parse('1/1/2020 ' + planned_end_time) > Date.parse('1/1/2020 ' + planned_start_time) ? null : { notGreater: true }
      }

    }
    else {
      return false;
    }
  }
  /* FormGroup custom validators with range value
    Author - Biswajit Manna */
  check_actual_end_time(group: FormGroup) {
    if (group.controls.actual_start_time.value != null && group.controls.actual_end_time.value != null) {
      let actual_start_time = group.controls.actual_start_time.value['hour'] + ':' + group.controls.actual_start_time.value['minute'] + ':' + group.controls.actual_start_time.value['second'];
      let actual_end_time = group.controls.actual_end_time.value['hour'] + ':' + group.controls.actual_end_time.value['minute'] + ':' + group.controls.actual_end_time.value['second'];
      var date_entry = group.controls.date_entry.value;
      var date_of_completion = group.controls.date_of_completion.value;
      if (date_entry != null && date_of_completion != null) {
        date_entry = group.controls.date_entry.value;
        date_of_completion = group.controls.date_of_completion.value;
        date_entry = date_entry.month + '/' + date_entry.day + '/' + date_entry.year;
        date_of_completion = date_of_completion.month + '/' + date_of_completion.day + '/' + date_of_completion.year;
        return Date.parse(date_of_completion + ' ' + actual_end_time) > Date.parse(date_entry + ' ' + actual_start_time) ? null : { notGreaterActual: true }
      }
      else {
        return Date.parse('1/1/2020 ' + actual_end_time) > Date.parse('1/1/2020 ' + actual_start_time) ? null : { notGreaterActual: true }
      }
    }
    else {
      return false;
    }
  }

  weatherChange(e){
    this.setDetailsData.emit(this.progressDetailsData)
  }
  milestoneChange(e){
    this.setDetailsData.emit(this.progressDetailsData)
  }

  progressSiteOnchange(val) {
    this.setSiteData.emit(val);
  }

  progressProjectOnChange(val) {
    this.setBoqData.emit(val);
  }

  onDateCompletionSelected() {
    if (this.progressDetailsData.date_of_completion) {
      this.setDetailsData.emit(this.progressDetailsData)
    }
  }

  onProgressDateSelected() {
    if (this.progressDetailsData.date_entry) {
      this.setDetailsData.emit(this.progressDetailsData)
      var date = this.settingService.getProperDate(this.progressDetailsData.date_entry)
      var str = 'date=' + date.toISOString().substr(0, 10);
      if (this.progressDetailsData.site_location != null && this.progressDetailsData.project_id != null) {
        this.reportService.fetchDailyProgressCommonData(this.progressDetailsData.project_id, this.progressDetailsData.site_location, str, 1).subscribe(
          res => {
            //console.log(res)
            if (res['result'] != '') {
              var date = new Date(res['result']['date_of_completion'])
              this.progressDetailsData.date_of_completion = {
                year: date.getFullYear(),
                month: date.getMonth() + 1,
                day: date.getDate()
              }
              this.progressDetailsData.weather = res['result']['weather'];
              this.progressDetailsData.temperature_in_cel = res['result']['temperature_in_cel'];
              this.progressDetailsData.milestone_to_be_completed = res['result']['milestone_to_be_completed'];
              this.progressDetailsData.ir_problem = res['result']['ir_problem'];
              this.progressDetailsData.local_issue = res['result']['local_issue'];
              this.progressDetailsData.client_visit = res['result']['client_visit'];
              this.progressDetailsData.administrative_issue = res['result']['administrative_issue'];
              this.progressDetailsData.boq = res['result']['boq'];
              this.onBOQSelection(this.progressDetailsData.boq);
              if(res['result']['rainfall_from'] != null) {
                let arr = res['result']['rainfall_from'].split(':');
                this.progressDetailsData.rainfall_from = {
                  "hour": arr[0],
                  "minute": arr[1]
                };
                this.progressDetailsData.rainfall_to = {
                  "hour": arr[0],
                  "minute": arr[1]
                };
              }
            }
            else {
              this.progressDetailsData.date_of_completion = null;
              this.progressDetailsData.weather = '';
              this.progressDetailsData.milestone_to_be_completed = '';
              this.progressDetailsData.ir_problem = null;
              this.progressDetailsData.local_issue = null;
              this.progressDetailsData.client_visit = null;
              this.progressDetailsData.administrative_issue = null;
              this.progressDetailsData.boq = null;
              this.boqDescription = '';
            }
            this.setDetailsData.emit(this.progressDetailsData)
          },
          error => {
            //console.log(error)
          }
        )
      }
    }

  }
  
  getMinDate() {
    const current = new Date();
    if (current.getMonth() == 0 && current.getDate() == 1) {
      return {
        year: current.getFullYear() - 1,
        month: 12,
        day: 31
      };
    }
    else if (current.getDate() == 1) {
      var dateObj = new Date();
      dateObj.setDate(0)
      return {
        year: dateObj.getFullYear(),
        month: dateObj.getMonth() + 1,
        day: dateObj.getDate()
      };
    }
    else {
      return {
        year: current.getFullYear(),
        month: current.getMonth() + 1,
        day: current.getDate() - 1
      };
    }

  }

  getCompletionMinDate(form: FormGroup) {
    if (form.value.date_entry) {
      return {
        year: form.value.date_entry.year,
        month: form.value.date_entry.month,
        day: form.value.date_entry.day
      };
    }
    else {
      const current = new Date();
      return {
        year: current.getFullYear(),
        month: current.getMonth() + 1,
        day: current.getDate() - 1
      };
    }
  }

  removeProgressDataFormGroup(index) {
    const control = <FormArray>this.form.controls['progress_data'];
    control.removeAt(index);
  }

  addButtonClick(): void {
    const control = <FormArray>this.form.controls['progress_data'];
    control.push(this.addProgressDataFormGroup());
  }
  
  getFormArrayControl(form) {
    return form.get('progress_data').controls
  }

  onDocumentSelect(event, fileFor) { console.log(event.target.files[0].type);
    if (event.target.files[0].type == "image/png" || event.target.files[0].type == "image/jpeg"
      || event.target.files[0].type == "image/jpg" || event.target.files[0].type == "image/jpj"
      || event.target.files[0].type == "application/pdf" || event.target.files[0].type == "application/doc" || event.target.files[0].type == "application/docx"
      || event.target.files[0].type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      || event.target.files[0].type == "application/msword"
    ) {
      if (event.target.files && event.target.files[0]) {
        var filesAmount = event.target.files.length;
        for (let i = 0; i < filesAmount; i++) {
          var reader = new FileReader();
          reader.onload = (event) => {
          }
          if(fileFor == "ai") {
            this.form.patchValue({
              document_ai: event.target.files[0]
            })
          } else if(fileFor == "li") {
            this.form.patchValue({
              document_li: event.target.files[0]
            })
          } else if(fileFor == "ir") {
            this.form.patchValue({
              document_ir: event.target.files[0]
            })
          } else if(fileFor == "cv") {
            this.form.patchValue({
              document_cv: event.target.files[0]
            })
          }
          reader.readAsDataURL(event.target.files[i]);
        }
      }
    } else {
      this.toastr.error('Image/PDF/Word file type allowed', '', {
        timeOut: 3000,
      });
    }
}

  savedata() {
    if (this.form.valid) {
      this.loading = LoadingState.Processing
      const formData: any = new FormData();
      formData.append('type_of_report', '1');
      formData.append('project_id', this.form.value.project_id);
      formData.append('site_location', this.form.value.site_location);
      formData.append('date_entry', this.settingService.getProperDate(this.form.value.date_entry).toISOString());
      formData.append('weather', this.form.value.weather);
      formData.append('date_of_completion', this.settingService.getProperDate(this.form.value.date_of_completion).toISOString());
      formData.append('milestone_to_be_completed', this.form.value.milestone_to_be_completed);
      formData.append('boq', this.form.value.boq);
      if(this.form.value.rainfall_from != '' && this.form.value.rainfall_from != null) {
        formData.append('rainfall_from', this.form.value.rainfall_from.hour + ':' + this.form.value.rainfall_from.minute);
      } 
      if(this.form.value.rainfall_to != '' && this.form.value.rainfall_to != null) {
        formData.append('rainfall_to', this.form.value.rainfall_to.hour + ':' + this.form.value.rainfall_to.minute);
      }
      formData.append('temperature_in_cel', this.form.value.temperature_in_cel);
      if(this.form.value.document_ir != null && this.form.value.document_ir != undefined){
        formData.append('ir_problem',this.form.value.document_ir);
      }
      if(this.form.value.document_li != null && this.form.value.document_li != undefined){
        formData.append('local_issue',this.form.value.document_li);
      }
      if(this.form.value.document_cv != null && this.form.value.document_cv != undefined){
        formData.append('client_visit',this.form.value.document_cv);
      }
      if(this.form.value.document_ai != null && this.form.value.document_ai != undefined){
        formData.append('administrative_issue',this.form.value.document_ai);
      }
      var progress_data = [];
      this.form.value.progress_data.forEach(x => {
        var assignee_details_id = x.assigned_to_id
        var assignee_details = []
        assignee_details_id.forEach(x => {
          var d = {
            assigned_to_id: x
          }
          assignee_details.push(d)
        })
        progress_data.push({
          activity_id: x.activity_id,
          archieved_quantity: x.archieved_quantity,
          contractors_name_id: x.contractors_name_id,
          description: x.description,
          major_achivements: x.major_achivements,
          remarks: x.remarks,
          uom_id: x.uom_id,
          assignee_details: assignee_details,
          assigned_to_id: null,
          planned_start_time: x.planned_start_time.hour + ':' + x.planned_start_time.minute + ':' + x.planned_start_time.second,
          planned_end_time: x.planned_end_time.hour + ':' + x.planned_end_time.minute + ':' + x.planned_end_time.second,
          actual_start_time: x.actual_start_time.hour + ':' + x.actual_start_time.minute + ':' + x.actual_start_time.second,
          actual_end_time: x.actual_end_time.hour + ':' + x.actual_end_time.minute + ':' + x.actual_end_time.second
        })
      });
      formData.append('progress_data', JSON.stringify(progress_data));
      this.reportService.saveProgressData(formData).subscribe(
        data => {
          this.form.reset();
          this.boqDescription = '';
          var res: any = data;
          this.toastr.success('Data has been succesfully saved !', '', {
            timeOut: 3000,
          });
          var objData = Object.assign([], this.form.value.progress_data)
          for (var i = objData.length - 1; i >= 0; i--) {
            this.removeProgressDataFormGroup(i)
          }
          this.progressDetailsData.ir_problem = null;
          this.progressDetailsData.client_visit = null;
          this.progressDetailsData.local_issue = null;
          this.progressDetailsData.administrative_issue = null;
          this.addButtonClick()
          this.loading = LoadingState.Ready
        },
        error => {
          this.toastr.error('Internal error occurred !', '', {
            timeOut: 3000,
          });
          this.loading = LoadingState.Ready
        }
      );
    }
    else {
      this.markFormGroupTouched(this.form);
    }
  }

  markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        control.controls.forEach(c => this.markFormGroupTouched(c));
      }
    });
  }

  isFieldValid(form: FormGroup, field: string) {
    return !form.get(field).valid && (form.get(field).dirty || form.get(field).touched);
  }

  displayFieldCss(form: FormGroup, field: string) {
    return {
      'is-invalid': form.get(field).invalid && (form.get(field).dirty || form.get(field).touched),
      'is-valid': form.get(field).valid && (form.get(field).dirty || form.get(field).touched)
    };
  }

  onBOQSelection(val) {
    if(val) {
      this.boqDescription = this.boqList.filter(x => x.id == val)[0]['item_description'];
    } else {
      this.boqDescription = null
    }
  }

  viewDoc(item: any) {
    window.open(item, '', 'height=700,width=800,scrollbars=yes');
  }

  removeDoc(source) {
    this.loading = LoadingState.Processing;
    if(source == 'ir') {
      this.progressDetailsData.ir_problem = null;
    } else if (source == 'cv') {
      this.progressDetailsData.client_visit = null;
    } else if (source == 'li') {
      this.progressDetailsData.local_issue = null;
    } else if (source == 'ai') {
      this.progressDetailsData.administrative_issue = null;
    }
    this.loading = LoadingState.Ready;
  }
}
